/**
 * Mã màn hình
 */
export default {
  ref_date: 1,
  ref_no: 2,
  ref_type: 3,
  posted_date: 4,
  inv_date: 5,
  inv_no: 6,
  debit_account: 7,
  credit_account: 8,
  amount: 9,
  budget_source_code: 10,
  budget_chapter_code: 11,
  budget_provide_code: 12,
  budget_kind_item_code: 13,
  budget_sub_kind_item_code: 14,
  method_distribute_type: 15,
  budget_item_code: 16,
  budget_sub_item_code: 17,
  accounting_object_code: 18,
  inventory_item_code: 19,
  inventory_item_tool_code: 20,
  quantity: 21,
  stock_code: 22,
  description: 23,
  activity_code: 24,
  cash_withdraw_type_id: 25,
  fixed_asset_code: 26,
  project_code: 27,
  fund_code: 28,
  department_code: 29,
  statistic_code: 30,
  is_treasury_approved: 31,
  approved_date: 32,
  debit_bank_account: 33,
  credit_bank_account: 34,
  bu_commitment_request_ref_no: 35,
  budget_source_property_code: 36,
  budget_fees_code: 37,
  contract_no: 38,
  contract_sell_no: 39,
  topic_code: 40,
  project_expense_code:41,
  budget_detail_item_code: 42,
  budget_group_item_code: 43,
  org_ref_date : 44,
  org_ref_no: 45
};
